import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

import classes from "./AccessabilityDeclaration.module.scss";

import HeaderImage from "../HeaderImage";

class AccessabilityDeclaration extends Component {
  state = {
    viewName: {
      firstLine: "הצהרת",
      secondLine: "נגישות"
    }
  };

  render() {
    return (
      <Container>
        <HeaderImage viewName={this.state.viewName} />
        <Container className="mx-2">
          <Row className={classes.header}>
            <Col>
              <h5 className={classes.headerText}>
                הנגשת אתר משרד הביטחון לאנשים עם מוגבלויות משרד הביטחון מייחס
                חשיבות עליונה להתאמת אתר האינטרנט שלו לגולשים עם מוגבלות פיזית,
                חושית וקוגניטיבית, מתוך תפיסת עולם לפיה יש לאפשר לכל בני האדם
                הזדמנות שווה ונגישות לשירות ולמידע.​
              </h5>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col>
              <div className={classes.textClass}>
                משרד הביטחון השקיע משאבים רבים בהנגשת האתר, על מנת לאפשר למרבית
                האוכלוסייה לגלוש בו בקלות ובנוחות וליהנות מהשירותים ומהתכנים
                המתפרסמים בו.
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <h5 className={classes.headerText}>אמצעי הנגישות באתר</h5>
            </Col>
          </Row>
          <Row>
            <Col className={classes.textClass}>
              <ul>
                <li>
                  אפשרות לש​ימוש מלא באמצעות קורא מסך המשמש גולשים עיוורים.
                </li>
                <li>
                  האתר מאפשר הגדלה של אותיות הכתב על יד שימוש במקש CTRL וגלגלת
                  העכבר.
                </li>
                <li>אמצעי הניווט וההתמצאות באתר נוחים לשימוש.</li>
                <li>
                  תוכני האתר כתובים בשפה בהירה ומאורגנים היטב באמצעות כותרות
                  ורשימות.
                </li>
                <li>
                  ניתן לגלוש באתר באמצעות שימוש במקלדת או טכנולוגיה מסייעת אחרת:
                  לחיצה חוזרת ונשנית על מקש ה- TAB מעבירה את הסמן בין הקישורים
                  השונים, לחיצה על מקש ENTER מפעילה את הקישור.
                </li>
                <li>עיצוב האתר מותאם ללקויי ראייה ולעיוורי צבעים.</li>
                <li>
                  האתר אינו כולל היבהובים ותכנים בתנועה (אנימציות, טקסט נע).
                  במידה וישנם תכנים כאלה יש אפשרות לעצור אותם.
                </li>
                <li>הקישורים באתר ברורים ומכילים הסבר לאן הם מובילים.</li>
                {/* <li>
                  האתר מאפשר דילוג על התפריטים וגישה ישירה לתוכן העמוד. יש ללחוץ
                  על מקש קיצור - Accesskey​ (לרוב Alt - ראה/י טבלת דפדפנים)
                  ומספר כדי לדלג לתוכן העמודים הבאים:&nbsp;
                </li> */}
              </ul>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <h5 className={classes.headerText}>סייגים לנגישות</h5>
            </Col>
          </Row>
          <Row>
            <Col className={classes.textClass}>
              תיתכן האפשרות שדף המסומן בתו הנגישות יציג בנוסף למידע הנגיש
              לשוניות מידע ותוכן מאתרים או ממערכות שטרם הונגשו, וזאת במסגרת
              המאמץ להציג מידע אינטגרטיבי ממקורות שונים. היות שלמשרד תוכן רב
              מעין זה, המבוסס על טכנולוגיה לא נגישה מדורות קודמים, ייעשה מאמץ
              מיוחד להנגישו בצורה הדרגתית לרמה AA.
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <h5 className={classes.headerText}>פניות בנושא נגישות האתר</h5>
            </Col>
          </Row>
          <Row>
            <Col className={classes.textClass}>
            אנו עושים מאמצים לתחזק את האתר ברמת נגישות גבוהה. אם נתקלתם בבעית נגישות באתר או שיש לכם שאלה או בקשה נשמח אם תפנו לדן אייל גזית 
            </Col>
          </Row>
          <Row>
            <Col className={classes.textClass}>
            בדוא"ל: gazitde@mod.gov.il
             
            </Col>
          </Row>
          <Row><Col className={classes.textClass}>טלפון: 03-6934688</Col></Row>
          <Row className="mt-3">
            <Col>
              <h5 className={classes.headerText}>פרטי רכז נגישות</h5>
            </Col>
          </Row>
          <Row>
            <Col className={classes.textClass}>
             שמואל מסיקה
            </Col>
          </Row>
          <Row>
            <Col className={classes.textClass}>
              דוא"ל: shmulik_m@mod.gov.il
            </Col>
          </Row>
          <Row>
            <Col className={classes.textClass}>
              טלפון: 052-6299398
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <h5 className={classes.headerText}>הנחיות הנגישות</h5>
            </Col>
          </Row>
          <Row>
            <Col className={classes.textClass}>
              ניתן לצפות בהנחיות להנגשת אתרי אינטרנט של ה- W3C:
            </Col>
          </Row>
          <Row>
            <Col className={classes.textClass}>
              גרסה 1 משנת 1999:{" "}
              <a
                href="http://www.w3.org/TR/WCAG10/"
                title="משרד הביטחון - הנחיות באנגלית"
                target="_blank"
              >
                הנחיות באנגלית
              </a>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col className={classes.textClass}>
              גרסה 2 מ- 11 בדצמבר 2008:{" "}
              <a
                href="http://www.w3c.org.il/guidelines/guidelines_WCAG_2.0.html"
                title="משרד הביטחון - הנחיות בעברית"
                target="_blank"
              >
                הנחיות בעברית&nbsp;
              </a>
              <a
                href="http://www.w3.org/TR/2008/REC-WCAG20-20081211/"
                title="משרד הביטחון - הנוכחית"
                target="_blank"
              >
                הנחיות באנגלית
              </a>
            </Col>
          </Row>
        </Container>
      </Container>
    );
  }
}

export default AccessabilityDeclaration;
